import * as v from "valibot";
import { rpcContract } from "../rpc";

const processingReportSchema = v.object({
  totalChunks: v.number(),
  processedChunks: v.number(),
  skippedChunks: v.number(),
  skippedDetails: v.array(v.object({ filename: v.string(), reason: v.string() })),
  downloadedChunks: v.array(v.object({ filename: v.string(), fileSizeBytes: v.number() })),
  chunkDetails: v.array(
    v.object({
      filename: v.string(),
      originalDurationSeconds: v.number(),
      trimmedDurationSeconds: v.number(),
    }),
  ),
  stageTiming: v.object({
    downloadDurationSeconds: v.number(),
    probeDurationSeconds: v.number(),
    processingDurationSeconds: v.number(),
    uploadDurationSeconds: v.number(),
    totalDurationSeconds: v.number(),
  }),
  resultFile: v.nullable(v.object({ sizeBytes: v.number(), durationSeconds: v.number() })),
  errors: v.array(v.object({ stage: v.string(), error: v.string(), timestamp: v.string() })),
  failedAtStage: v.nullable(v.string()),
});

export const updateRecordingStatusRpcContract = rpcContract({
  name: "update-recording-status",
  paramsSchema: v.object({
    jobId: v.string(),
    status: v.picklist(["completed", "failed"]),
    recordingUrl: v.nullish(v.string()),
    errorMessage: v.nullish(v.string()),
    summary: v.optional(processingReportSchema),
  }),
  resultSchema: v.object({ success: v.boolean() }),
});

export type UpdateRecordingStatusParams = v.InferOutput<(typeof updateRecordingStatusRpcContract)["paramsSchema"]>;
export type UpdateRecordingStatusResult = v.InferOutput<(typeof updateRecordingStatusRpcContract)["resultSchema"]>;
